<template>
  <label :for="_uid" class="toggle-button" :class="'toggle-button--' + align">
    <input
      class="toggle-button__checkbox"
      type="checkbox"
      :id="_uid"
      :checked="checked"
      @change="updateChecked"
    />
    <span class="toggle-button__toggler" :class="checked ? 'on' : 'off'" >
      <em class="toggle-button__icon"> </em>
      <i v-if="checked">{{translations['threesixtyOn']}}</i>
      <i v-else>{{translations['threesixtyOff']}}</i>
    </span>
    <span class="toggle-button__label" :class="'toggle-button__label--' + align" v-html="label"></span>
  </label>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  model: {
    prop: 'checked',
  },
  props: {
    label: String,
    checked: Boolean,
    align: {
      type: String,
      default: 'right',
    },
  },
  computed: {
    ...mapGetters(['translations']),
  },
  methods: {
    updateChecked(event) {
      this.$emit('change', event.target.checked);
    },
  },
};
</script>

<style lang="scss">
  @import '../scss/helpers.scss';

  .toggle-button {
    cursor: pointer;
    display: flex;
    align-items: center;
    position: relative;

    &:not(:last-child) {
      margin-right: 20px;
    }

    &--left {
      margin-right: 0;

      &:not(:first-child) {
        margin-left: 20px;
      }
      flex-direction: row-reverse;
    }

    &__checkbox {
      position: absolute;
      visibility: hidden;
    }

    &__label {
      font-size: 12px;
      font-weight: 300;
      color: #000;
      margin-left: 20px;

      &--left {
        margin-right: 20px;

        @include landscape {
          margin-left: 0px;
        }
      }
    }

    &__icon {
      &:before, &:after {
        content: '';
        background: #fff;
        display: block;
        height: 2px;
        left: 45px;
        position: absolute;
        top: 15px;
        transform: rotate(-45deg);
        width: 18px;
        z-index: 10;
        transition: all .25s;
      }

      &:before {
        transform: rotate(45deg);
      }

      .on & {
        &:after {
          left: 3px;
          top: 16px;
          z-index: 10;
          transform: rotate(-225deg);
        }

        &:before {
          left: -2px;
          top: 18px;
          width: 9px;
          transform: rotate(-135deg);
        }
      }      
    }

    &__toggler {
      background: #E6EBEF;
      border-radius: 20px;
      box-sizing: border-box;
      color: #000;
      display: inline-block;
      font-size: 12px;
      line-height: 20px;
      font-weight: 300;
      height: 34px;
      padding: 7px 12px;
      position: relative;
      vertical-align: middle;
      width: 63px;
      text-align: right;
      transition: all .25s;
      z-index: 0;

      img {
        position: absolute;
        top: 10px;
        z-index: 2;
      }

      i {
        font-style: normal;
      }

      &:before {
        content: '';
        background: #0096C3;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: block;
        position: absolute;
        top: -3px;
        z-index: 1;
        box-shadow: 0px 2px 2px rgba(0,0,0,0.31);
        transition: all .25s;
      }

      &.on {
        &::before { left: -12px; }
        img { left: -1px; }
      }

      &.off {
        text-align: left;
        background: rgba(0,0,0,.5);

        &::before { left: 34px; }
        img { right: 1px; }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ToggleButton.vue